import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { MenuItem, MenuItemType } from '@models/menu-item';
import { VersionService } from '@services/version.service';

@Component({
  standalone: false,
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  menuItemType = MenuItemType;
  mode = 0;
  appVersion: string = '';


  @Input() menuItems: MenuItem[];

  constructor(private versionService: VersionService) { }

  ngOnInit(): void {
    this.appVersion = this.versionService.getVersion();
  }



}
